// extracted by mini-css-extract-plugin
export default {"downsale":"style_downsale__LyjSw","bottom":"style_bottom__Mw66d","active":"style_active__PP67f","modal":"style_modal__Q+xDD","close":"style_close__RgLva"};